module.exports = __webpack_public_path__ + "static/img/pinterest-icon-detail.00c284e.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/pinterest-icon-detail.png
// module id = YX5X
// module chunks = 46